import { render, staticRenderFns } from "./x-sortable.vue?vue&type=template&id=24ba76c5"
import script from "./x-sortable.vue?vue&type=script&lang=ts"
export * from "./x-sortable.vue?vue&type=script&lang=ts"
import style0 from "./x-sortable.vue?vue&type=style&index=0&id=24ba76c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports